import React from 'react';

const PieChart = ({ data, title }) => {
  // Filter out zero values and handle empty data
  const filteredData = (data || []).filter(item => item.value > 0);
  const total = filteredData.reduce((sum, item) => sum + item.value, 0);
  let cumulativePercentage = 0;
  
  // Handle empty or zero-total state
  if (!filteredData.length || total === 0) {
    return (
      <div className="bg-white rounded-lg p-4 shadow">
        {title && <h3 className="font-medium mb-4">{title}</h3>}
        <div className="flex items-center justify-center h-32 text-gray-400">
          <p className="text-sm">No data yet</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-white rounded-lg p-4 shadow">
      {title && <h3 className="font-medium mb-4">{title}</h3>}
      <div className="flex">
        <div className="w-32 h-32 relative">
          <svg viewBox="0 0 100 100" className="w-full h-full">
            {filteredData.map((item, index) => {
              const percentage = (item.value / total) * 100;
              
              const startAngle = (cumulativePercentage / 100) * 360;
              cumulativePercentage += percentage;
              const endAngle = (cumulativePercentage / 100) * 360;
              
              const startRadians = (startAngle - 90) * (Math.PI / 180);
              const endRadians = (endAngle - 90) * (Math.PI / 180);
              
              const startX = 50 + 40 * Math.cos(startRadians);
              const startY = 50 + 40 * Math.sin(startRadians);
              const endX = 50 + 40 * Math.cos(endRadians);
              const endY = 50 + 40 * Math.sin(endRadians);
              
              const largeArcFlag = percentage > 50 ? 1 : 0;
              
              const pathData = [
                `M 50 50`,
                `L ${startX} ${startY}`,
                `A 40 40 0 ${largeArcFlag} 1 ${endX} ${endY}`,
                `Z`
              ].join(' ');
              
              return (
                <path
                  key={index}
                  d={pathData}
                  fill={item.color}
                  stroke="white"
                  strokeWidth="1"
                />
              );
            })}
          </svg>
        </div>
        <div className="ml-4 flex-1">
          <div className="space-y-2">
            {filteredData.map((item, index) => (
              <div key={index} className="flex items-center">
                <div 
                  className="w-3 h-3 rounded-sm mr-2" 
                  style={{ backgroundColor: item.color }}
                ></div>
                <div className="text-sm flex-1">{item.label}</div>
                <div className="text-sm font-medium">{Math.round((item.value / total) * 100)}%</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieChart;